import {Link, useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../../components/shared/Loader";
import StarIcon from "../../../images/icons/starIcon";
import NoImage from "../../../images/NoImage.jpg";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import AttachedFiles from "../../components/offer/offerFiles";
import {
  InterventionInfo,
  InterventionInfoDirect,
} from "../../components/Intervention/interventionInfo";
import {
  InterventionInfoDirectClient,
  InterventionInfoClient,
} from "../../components/Intervention/interventionInfoClient";

import {useGetIntervention} from "../../../hooks/useInterventions";
import {userRoleList} from "../../../utils/constants";
import InterventionReport from "../../components/Intervention/interventionReport";
import RecapReport from "../../components/Intervention/recapReport";
import QueryErrorState from "../../components/shared/QueryErrorState";

const InterventionPage = () => {
  const {data, isError, isLoading, error, refetch} = useGetIntervention();
  const {
    data: user,
    isLoading: isMeLoading,
    isError: isMeError,
    error: meError,
    refetch: refetchMe,
  } = useMe();
  const navigate = useNavigate();
  const {id: routeIdentifier} = useParams();

  useEffect(() => {
    if (data?.publicId && routeIdentifier !== data.publicId) {
      navigate(`/intervention/${data.publicId}`, {replace: true});
    }
  }, [data?.publicId, navigate, routeIdentifier]);

  if (isLoading || isMeLoading) return <Loader />;
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  if (isMeError) {
    return <QueryErrorState error={meError} onRetry={refetchMe} />;
  }

  const userProfile =
    user?.selectedRole === userRoleList.TECHNICIAN
      ? !!data?.Offer_Proposal?.Offer
        ? data?.Offer_Proposal?.Offer?.Client
        : data?.Offer_Proposal?.directChat?.chatroom?.Client
      : data?.Offer_Proposal?.Technician;

  return (
    <>
      <div className="w-full flex flex-col lg:grid lg:grid-cols-4 gap-6 ">
        <div className="w-full h-fit   px-4 lg:!px-0  lg:block ">
          <Link
            to={
              user?.selectedRole === userRoleList.TECHNICIAN
                ? `/client/${userProfile?.id}`
                : `/prestataire/${userProfile?.id}`
            }
            className="flex gap-3 lg:gap-0 lg:flex-col rounded-2xl bg-white justify-start items-center  p-4"
          >
            <div className="relative lg:mt-4 ">
              {!!userProfile?.User?.avgRating && (
                <Link
                  to={
                    user?.selectedRole === userRoleList.TECHNICIAN
                      ? `/client/${userProfile?.id}`
                      : `/prestataire/${userProfile?.id}/#avis`
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="bg-[#FFC107] w-[38px] flex justify-center gap-[2px] items-center  p-[1px] text-white leading-3 text-[10px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] "
                >
                  {Number(userProfile?.User?.avgRating).toFixed(2)}
                  <StarIcon className="fill-white stroke-none w-2 h-2" />
                </Link>
              )}
              <ImageComponent
                src={buildImageUrl(userProfile?.User?.imageUri)}
                alt=""
                className=" w-14  lg:w-[104px] aspect-square rounded-full object-cover ring-4 ring-white"
                fallback={
                  <img
                    src={NoImage}
                    alt=""
                    className=" w-14  lg:w-[104px] aspect-square rounded-full object-cover"
                    width="130"
                  />
                }
              />
            </div>
            <div className="flex flex-col rounded-2xl bg-white justify-start items-start lg:items-center">
              <div className="lg:text-center text-[#19295C] font-semibold lg:mt-3 capitalize">
                {`${userProfile?.User.lastName}  ${userProfile?.User.firstName}`}
              </div>
              <div className="lg:text-center text-primary font-normal text-sm">
                {user?.selectedRole === userRoleList.TECHNICIAN
                  ? "Client"
                  : "Prestataire"}
              </div>
            </div>
            {/* <div className="text-right lg:text-center flex-grow  lg:flex-grow-0 text-xs font-normal lg:mt-3  underline text-[#7E7E7E] ">
              (78 évaluations)
            </div> */}
          </Link>
        </div>
        <div className="w-full col-span-2 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-3">
          {user?.selectedRole === userRoleList.TECHNICIAN ? (
            !!data?.Offer_Proposal?.Offer ? (
              <InterventionInfo intervention={data} />
            ) : (
              <InterventionInfoDirect intervention={data} />
            )
          ) : !!data?.Offer_Proposal?.Offer ? (
            <InterventionInfoClient intervention={data} />
          ) : (
            <InterventionInfoDirectClient intervention={data} />
          )}
          {data?.ended_byTech && (
            <InterventionReport
              files={data?.FileUploads ?? []}
              intervention={data}
            />
          )}
          {((data?.reported_byClient && !data?.reported_byTech) ||
            (data?.reported_byTech && !data?.reported_byClient)) && (
            <RecapReport intervention={data} role={user?.selectedRole} />
          )}
        </div>

        <div className="w-full px-4 lg:!px-0  lg:flex flex-col gap-4 ">
          <AttachedFiles
            files={data?.Offer_Proposal?.Offer?.FileUploads ?? []}
          />
        </div>
      </div>
    </>
  );
};
export default InterventionPage;
